import { useIsScoped } from '../hooks/useIsScoped';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Provides an `isScoped` utility to the wrapped component. This is only
 * to assist in the migration off of `GlobalScopesContainer`. Eventually these
 * usages should all be replaced with props, `useTimelineAuthContext`, or
 * `hub-http/userInfo` calls.
 *
 * @deprecated Please prefer accessing scopes via passing props, calling
 * `hub-http/userInfo`, or via `TimelineAuthContext`
 * @param {React.ElementType} Component The component to provide `isScoped` to
 */
export function WithScopes(Component) {
  function ComponentWithScopes(props) {
    const isScoped = useIsScoped();
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      isScoped: isScoped
    }));
  }
  ComponentWithScopes.displayName = `WithScopes(${Component.name || Component.displayName || 'anonymous'})`;
  ComponentWithScopes.WrappedComponent = Component;
  return ComponentWithScopes;
}